export const locationLinks = [
  {
    label: 'Ajax',
    url: '',
  },
  {
    label: 'Barrie',
    url: '',
  },
  {
    label: 'Brampton',
    url: '',
  },
  {
    label: 'Brantford',
    url: '',
  },
  {
    label: 'Burlington',
    url: '',
  },
  {
    label: 'Cambridge',
    url: '',
  },
  {
    label: 'Cayuga',
    url: '',
  },
  {
    label: 'Etobicoke',
    url: '',
  },
  {
    label: 'Hagersville',
    url: '',
  },
  {
    label: 'Hamilton',
    url: '',
  },
  {
    label: 'Kitchener',
    url: '',
  },
  {
    label: 'Lindsay',
    url: '',
  },
  {
    label: 'London',
    url: '',
  },
  {
    label: 'Milton',
    url: '',
  },
  {
    label: 'Niagara Falls',
    url: '',
  },
  {
    label: 'Oakville',
    url: '',
  },
  {
    label: 'Pickering',
    url: '',
  },
  {
    label: 'Prince Edward County',
    url: '',
  },
  {
    label: 'Richmond Hill',
    url: '',
  },
  {
    label: 'Shelbourne',
    url: '',
  },
  {
    label: 'St. Catharines',
    url: '',
  },
  {
    label: 'Stratford',
    url: '',
  },
  {
    label: 'Toronto',
    url: '',
  },
  {
    label: 'Waterloo',
    url: '',
  },
  {
    label: 'Whitby',
    url: '',
  },
  {
    label: 'Woodbridge',
    url: '',
  },
]

export const projectTypeLinks = [
  {
    label: 'Condos',
    url: '',
  },
  {
    label: 'Detached',
    url: '',
  },
  {
    label: 'Townhomes',
    url: '',
  },
  {
    label: 'Bungalow',
    url: '',
  },
]

export const occupancyLinks = [
  {
    label: '2020',
    url: '',
  },
  {
    label: '2021',
    url: '',
  },
  {
    label: '2022',
    url: '',
  },
  {
    label: '2023',
    url: '',
  },
  {
    label: '2024',
    url: '',
  },
  {
    label: '2025',
    url: '',
  },
  {
    label: '2026',
    url: '',
  },
  {
    label: '2027',
    url: '',
  },
  {
    label: '2028',
    url: '',
  },
  {
    label: '2029',
    url: '',
  },
  {
    label: '2030',
    url: '',
  },
  {
    label: '2031',
    url: '',
  },
  {
    label: '2032',
    url: '',
  },
  {
    label: '2033',
    url: '',
  },
  {
    label: '2034',
    url: '',
  },
  {
    label: '2035',
    url: '',
  },
  {
    label: '2036',
    url: '',
  },
  {
    label: 'TBA',
    url: '',
  },
]

export const statusLinks = [
  {
    label: 'Coming Soon',
    url: '',
  },
  {
    label: 'Platinum Access',
    url: '',
  },
  {
    label: 'Assignment',
    url: '',
  },
  {
    label: 'Sold Out',
    url: '',
  },
  {
    label: 'Now Selling',
    url: '',
  },
  {
    label: 'VIP Sale',
    url: '',
  },
]
